function TipsAr(){
    return (
        <>
        <div className="Tips" dir="rtl">
            <div className="haye">
            <div className="tips_container">
                <div className="left_tips">
                <img src="/Images/01.png"  alt="image_tips"/>
                </div>
                <div className="right_tips">
                    <div className="tap">
                        <div className="icon">
                        <i className="fa-solid fa-circle-check"></i>
                        </div>
                        <div className="qoraal">
                            <h2>إختر</h2>
                            <p className="info_tips" style={{textAlign: "right"}}>هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص عدد</p>
                        </div>
                    </div>
                    <div className="tap">
                        <div className="icon">
                        <i className="fa-solid fa-circle-check"></i>
                        </div>
                        <div className="qoraal">
                        <h2>جهز</h2>
                        <p className="info_tips" style={{textAlign: "right"}}>هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا الند</p>
                        </div>
                    </div>
                    <div className="tap">
                        <div className="icon">
                        <i className="fa-solid fa-circle-check"></i>
                        </div>
                        <div className="qoraal">
                        <h2>حمل</h2>
                        <p className="info_tips" style={{textAlign: "right"}}>هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص </p>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        
        </>
    )
}


export default TipsAr